import { createReducer, on, Action } from "@ngrx/store";
import { AccountEntityRaw } from "@youm-front/account/domain";
import { Conf2Actions } from "@youm-front/conf2/data-access";
import { AccountActions } from "../actions";
import { Conf2SignInFailureReason } from "../conf2-sign-in-failure";

export const ACCOUNT_FEATURE_KEY = "account";

export interface AccountState {
  account: null | AccountEntityRaw;
  isLoading: boolean;
  conf2SignInFailure: null | Conf2SignInFailureReason;
}

export const initialAccountState: AccountState = {
  account: null,
  isLoading: false,
  conf2SignInFailure: null
};

const reducer = createReducer(
  initialAccountState,
  on(AccountActions.guestAccountSignIn, (state) => ({
    ...state,
    isLoading: true
  })),
  on(
    AccountActions.guestAccountSignInFailure,
    AccountActions.guestAccountSignInSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(AccountActions.meSuccess, (state, { account }) => ({
    ...state,
    account: account.toJSON()
  })),
  on(AccountActions.conf2SignInFailure, (state, { reason }) => ({
    ...state,
    conf2SignInFailure: reason
  })),
  on(
    Conf2Actions.conf2AccountSignIn,
    AccountActions.signInSuccess,
    (state) => ({
      ...state,
      conf2SignInFailure: null
    })
  ),
  on(AccountActions.meSignOut, () => initialAccountState)
);

export function accountReducer(
  state: AccountState | undefined,
  action: Action
) {
  return reducer(state, action);
}
